import Main from './main';
import Loader from './loader';
import Deposit from './deposit';
import Cashout from './cashout';
import Tasks from './tasks';
import Verification from './verification';
import MoonPay from './moonpay';
import BuyCrypto from './buy_crypto';
import Cashback from './cashback_new';
import Halloween from './halloween';
// import CashbackNew from './cashback_new';

export default {
    Main,
    Loader,
    Deposit,
    Cashout,
    Tasks,
    Verification,
    MoonPay,
    BuyCrypto,
    Cashback,
    Halloween
}